<template>
  <information-default
    :nameButton="$t('views.RegisterByEmail.RegisterSuccess.nameButton')"
    :title="$t('views.RegisterByEmail.RegisterSuccess.title')"
    action="middleware-game"
  ></information-default>
</template>
<script>
import InformationDefault from "../../components/Sections/InformationDefault";
export default {
  components: {
    InformationDefault
  },

};
</script>
<style lang="scss" scoped>
</style>
